import {
  Autocomplete,
  CardActions,
  CardContent,
  CardHeader,
  Dialog,
  FormControl,
  FormHelperText,
  Grid,
  Paper,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AppButton from "../../../shares/AppButton";
import useToast from "../../../../../hooks/useToast";
import AutreCompetenceNiveau from "./AutreCompetenceNiveau";
import { TYPE_NOTIFICATION } from "../../../shares/NotificationBull";
import { CVService } from "../../../../../service/CVService";
import { useQuery } from "../../../../../hooks/useQuery";
const INIT_AUTRE_COMPETENCE = {
  id_competence: null,
  id_identity: null,
  competence: "",
  type: "",
  niveau: "",
};

const INIT_FORM_ERROR = {
  competence_error: null,
  type_error: null,
  niveau_error: null,
};
const AutreCompetenceForm = ({
  open,
  onFormClose,
  onFormOpen,
  idAutreCompetence,
}) => {
  const [currentAutreCompetence, setCurrentAutreCompetence] = useState(
    INIT_AUTRE_COMPETENCE
  );
  const [formErrors, setFormErrors] = useState(INIT_FORM_ERROR);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const options = ["Langue", "Informatique", "Autre"];
  const { Toast, showToast } = useToast();
  const query = useQuery();
  const id_identite = query.get("id_identite");

  const handleFormClose = () => {
    onFormClose();
    initAll();
  };

  const initAll = () => {
    setCurrentAutreCompetence(INIT_AUTRE_COMPETENCE);
    setFormErrors(INIT_FORM_ERROR);
    setIsSubmitted(false);
    setLoading(false);
  };

  const handleChangeCurrentAutreCompetence = (e) => {
    const { name, value } = e.target;
    setCurrentAutreCompetence((prev) => ({
      ...prev,
      [name]: value || "",
    }));
  };

  const handleFetchData = () => {
    CVService.getAutreCompetenceById(idAutreCompetence).then((res) => {
      if (res && res.data) {
        setCurrentAutreCompetence(res.data);
      }
    });
  };

  const handleCheckError = () => {
    setFormErrors({
      competence_error: !currentAutreCompetence.competence
        ? "Champ compétence requis"
        : null,
      type_error: !currentAutreCompetence.type ? "Champ type requis" : null,
      niveau_error: !currentAutreCompetence.niveau
        ? "Champ niveau requis"
        : null,
    });
    return Object.values(formErrors).every((error) => error === null);
  };

  const handleInsertAutreCompetence = () => {
    let copy_currentAutreCompetence = { ...currentAutreCompetence };
    copy_currentAutreCompetence.id_identity = id_identite;
    CVService.insertAutreCompetence(copy_currentAutreCompetence).then((res) => {
      if (res && res.success) {
        showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
        handleFormClose();
      } else {
        showToast(TYPE_NOTIFICATION.ERROR, res.message);
      }
    });
  };
  const handleUpdateAutreCompetence = () => {
    CVService.updateAutreCompetence(currentAutreCompetence).then((res) => {
      if (res && res.success) {
        showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
        handleFormClose();
      } else {
        showToast(TYPE_NOTIFICATION.ERROR, res.message);
      }
    });
  };

  const handleSubmit = () => {
    setIsSubmitted(true);
    setLoading(true);
    if (handleCheckError()) {
      if (idAutreCompetence) {
        handleUpdateAutreCompetence();
      } else {
        handleInsertAutreCompetence();
      }
    } else {
      showToast(
        TYPE_NOTIFICATION.ERROR,
        "Veuillez remplir tous les champs obligatoires"
      );
    }
  };

  useEffect(() => {
    if (open && idAutreCompetence) handleFetchData();
  }, [open, idAutreCompetence]);

  useEffect(() => {
    handleCheckError();
  }, [currentAutreCompetence]);

  return (
    <>
      <Toast />
      <Dialog open={open} onClose={handleFormClose} fullWidth maxWidth="xs">
        <Paper sx={{ m: 3 }} elevation={0}>
          <Grid>
            <CardHeader title="Autre competence" />
            <CardContent>
              <Grid container>
                <FormControl fullWidth>
                  <label>Domaine *</label>
                  <Autocomplete
                    freeSolo
                    name="competence"
                    id="competence"
                    options={options}
                    value={currentAutreCompetence.competence || ""}
                    onChange={(event, newValue) => {
                      handleChangeCurrentAutreCompetence({
                        target: { name: "competence", value: newValue || "" },
                      });
                    }}
                    onInputChange={(event, newInputValue) => {
                      handleChangeCurrentAutreCompetence({
                        target: { name: "competence", value: newInputValue || "" },
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        id="competence"
                        name="competence"
                        size="small"
                        placeholder="Compétence"
                        fullWidth
                        error={formErrors.competence_error && isSubmitted}
                        helperText={isSubmitted ? formErrors.competence_error : ""}
                        aria-describedby="competence_helper"
                      />
                    )}
                  />
                  <FormHelperText id="competence_helper"></FormHelperText>
                </FormControl>
                <FormControl fullWidth>
                  <label>Competence *</label>
                  <TextField
                    id="type"
                    name="type"
                    onChange={handleChangeCurrentAutreCompetence}
                    size="small"
                    placeholder="Type de Compétence"
                    fullWidth
                    value={currentAutreCompetence.type}
                    error={formErrors.type_error && isSubmitted}
                    helperText={isSubmitted ? formErrors.type_error : ""}
                    aria-describedby="type_helper"
                  />
                  <FormHelperText id="type_helper"></FormHelperText>
                </FormControl>
                <FormControl fullWidth>
                  <label>Niveau</label>
                  <TextField
                    sx={{ display: "none" }}
                    id="niveau"
                    name="niveau"
                    onChange={handleChangeCurrentAutreCompetence}
                    size="small"
                    placeholder="Niveau de competence"
                    fullWidth
                    value={currentAutreCompetence.niveau}
                    error={formErrors.niveau_error && isSubmitted}
                    helperText={isSubmitted ? formErrors.niveau_error : ""}
                    aria-describedby="niveau_helper"
                  />
                  <AutreCompetenceNiveau
                    value={currentAutreCompetence.niveau.split(",") || []}
                    onChange={(val) =>
                      setCurrentAutreCompetence({
                        ...currentAutreCompetence,
                        niveau: val,
                      })
                    }
                    typeCompetence={currentAutreCompetence.competence}
                    error={formErrors.niveau_error && isSubmitted}
                    helperText={isSubmitted ? formErrors.niveau_error : ""}
                  />
                  <FormHelperText id="niveau_helper"></FormHelperText>
                </FormControl>
              </Grid>
            </CardContent>
            <CardActions sx={{ justifyContent: "flex-end" }}>
              <AppButton
                text={"Enregistrer"}
                size={"medium"}
                variant={"contained"}
                onClick={handleSubmit}
                loading={loading}
              />
              <AppButton
                text={"Fermer"}
                onClick={handleFormClose}
                size={"medium"}
                variant={"outlined"}
              />
            </CardActions>
          </Grid>
        </Paper>
      </Dialog>
    </>
  );
};

export default AutreCompetenceForm;
